/**
 * Dummy origin used to resolve relative paths via the `URL` constructor.
 * The origin itself is irrelevant — we only ever read `.pathname`.
 */
const PATHNAME_BASE = 'http://localhost';

/**
 * Returns the pathname portion of a path-like string, stripping any query
 * string and hash fragment. SSR-safe (uses a synthetic base URL).
 *
 * Preferred over manual `split('?')[0]?.split('#')[0]` chains because it
 * correctly handles encoded characters, hash-before-query orderings, and
 * other URL edge cases via the standard parser.
 *
 * @param path - A path or path-with-query/hash (e.g. `/foo?a=1#bar`). Falsy
 *               values and parse errors yield {@link fallback}.
 * @param fallback - Returned when the input is empty/invalid. Defaults to `'/'`.
 *
 * @example
 *   extractPathname('/foo?a=1#bar') // '/foo'
 *   extractPathname('/foo/')        // '/foo/'
 *   extractPathname('', '/home')    // '/home'
 */
export function extractPathname(path: string | null | undefined, fallback = '/'): string {
  if (!path) return fallback;
  try {
    return new URL(path, PATHNAME_BASE).pathname || fallback;
  } catch {
    return fallback;
  }
}
